import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import Section from '../Inputs/Section'
import { Divider, Form, Grid, Header } from 'semantic-ui-react'
import { ConformAdequat, ConformYes, FromTo, Years, YesNo } from '../../../utils/FormSelectHelper'
import Input from '../Inputs/Input'
import Select from '../Inputs/Select'
import { Line } from 'react-chartjs-2'
import { autorun } from 'mobx'
import Checkbox from '../Inputs/Checkbox'
import { observer } from 'mobx-react'

@observer
class RIGPMP000 extends Component {
  static propTypes = {
    equipment: PropTypes.instanceOf(FormEntry)
  }

  state = {
    pompeVertical: false,
    pompeSourceEau: false,
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      },
      tooltips: {
        enabled: true
      },
      hover: {
        animationDuration: 0
      }
    },
    data: {
      datasets: [{
        label: 'Pressions',
        data: [],
        backgroundColor: 'rgba(243, 19, 179, 0.7)',
        borderColor: 'rgb(243, 19, 179)',
        fill: false,
        borderWidth: 2,
        tension: 0.2
      }, {
        label: 'Pourcentage de débit',
        data: [],
        backgroundColor: 'rgba(3, 31, 74, 0.7)', // #031f4b
        borderColor: 'rgb(3, 31, 74)', // #031f4b
        fill: false,
        borderWidth: 2,
        tension: 0.3
      }],
      labels: []
    }
  }

  componentDidMount () {
    const { equipment } = this.props
    const { data } = this.state
    this.setState({
      pompeVertical: equipment.forms_datas.pompeVertical && equipment.forms_datas.pompeVertical.value,
      pompeSourceEau: equipment.forms_datas.pompeSourceEau && equipment.forms_datas.pompeSourceEau.value !== 'ville'
    })
    this.autorun = autorun(() => {
      const newData = data
      newData.datasets[0].data = []
      if (equipment.getValue('pompePressionShutOff')) {
        newData.datasets[0].data.push({ x: 0, y: parseInt(equipment.getValue('pompePressionShutOff')) })
        if (!newData.labels.includes(0)) {
          newData.labels.push(0)
        }
      }
      if (equipment.getValue('pompePressionNominal')) {
        newData.datasets[0].data.push({ x: 100, y: parseInt(equipment.getValue('pompePressionNominal')) })
        if (!newData.labels.includes(100)) {
          newData.labels.push(100)
        }
      }
      if (equipment.getValue('pompePression150')) {
        newData.datasets[0].data.push({ x: 150, y: parseInt(equipment.getValue('pompePression150')) })
        if (!newData.labels.includes(150)) {
          newData.labels.push(150)
        }
      }
      newData.datasets[1].data = []
      for (let i = 1; i <= 7; i++) {
        if (equipment.getValue(`tableauCapacite${i}`) && equipment.getValue(`tableauNet${i}`)) {
          if (!newData.labels.includes(parseInt(equipment.getValue(`tableauCapacite${i}`)))) {
            newData.labels.push(parseInt(equipment.getValue(`tableauCapacite${i}`)))
          }
          newData.datasets[1].data.push({
            x: parseInt(equipment.getValue(`tableauCapacite${i}`)),
            y: parseInt(equipment.getValue(`tableauNet${i}`))
          })
        }
      }
      newData.labels = newData.labels.sort((a, b) => a - b)
      this.setState({ data: newData })
    })
  }

  componentWillUnmount () {
    this.autorun()
  }

  render () {
    const { equipment } = this.props
    const { options, data, pompeVertical, pompeSourceEau } = this.state

    return (
      <>
        <Form>
          <Section title={(<Header as='h2'>1. VÉRIFICATION POMPE</Header>)} name='10pompeIncendie' equipment={equipment}>
            <Divider />
            <Header as='h5'>1.1 SYSTÈME DE LA POMPE</Header>
            <Form.Group widths='equal'>
              <Select name='tempPieceAdequat' formEntry={equipment} options={ConformYes()} isFixed label='1.1.1 Température de la pièce adéquat' />
              <Select name='tuyauterieEssaiDebitmetreAdequat' formEntry={equipment} options={ConformYes()} isRequired label="1.1.3 Tuyauterie d'essai du débitmètre adéquat" />
              <Select name='pompeLubrifie' formEntry={equipment} options={YesNo()} isFixed label='1.1.12 Pompe lubrifié' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='voletVentilationAdequatOperationnel' formEntry={equipment} options={ConformYes()} isFixed label='1.1.2 Volets de ventilation adéquat/opérationnel' />
              <Select name='manometreCalibre' className='second-title' formEntry={equipment} options={ConformYes()} isFixed label='1.1.3.1 Manomètre calibré' />
              <Select name='conditionArbreEntrainement' formEntry={equipment} options={ConformAdequat()} isRequired label="1.1.13 Condition de l'arbre d'entrainement" />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='valvesPositionNormal' formEntry={equipment} options={ConformYes()} isFixed label='1.1.3 Les valves sont en position normale' />
              <Select name='diametreAlimentationSortie' formEntry={equipment} options={FromTo(1, 12)} isRequired label="1.1.4 Diamètre de l'alimentation et de la sortie (po.)" />
              <Select name='manometreCapteur' formEntry={equipment} options={ConformAdequat()} isRequired label='1.1.14 Manomètre et capteurs (a.)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='valveEntreTypeOSY' formEntry={equipment} options={ConformYes()} isRequired label="1.1.4 Valve d'entrée est de type OSY (50' et moins)" />
              <Select name='diametreTuyauterieContournement' formEntry={equipment} options={FromTo(1, 12)} isRequired label='1.1.5 Diamètre de la tuyauterie de contournement (po.)' />
              <Select name='alignementAccouplement' formEntry={equipment} options={ConformAdequat()} isRequired label='1.1.15 Alignement des accouplements' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='valveEntreTypeNormalementFerme' formEntry={equipment} options={ConformYes()} isRequired label="1.1.5 Valve d'essai de type normalement fermé" />
              <Select name='valveContournement' formEntry={equipment} options={ConformYes()} isRequired label='1.1.6 Valve de contournement' />
              <Select name='conditionExterneTuyauterie' formEntry={equipment} options={ConformAdequat()} isRequired label='1.1.16 Condition externe de la tuyauterie' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='tuyauterieRaccordEassiAdequat' formEntry={equipment} options={ConformYes()} isRequired label="1.1.2 Tuyauterie et raccord d'essai adéquat" />
              <Select name='vlapetRetenue' formEntry={equipment} options={ConformYes()} isRequired label='1.1.11 Clapet de retenue' />
              <div className='field' />
            </Form.Group>
            <Divider />
            <Header as='h5'>1.2 TRANSMISSION MÉCANIQUE</Header>
            <Form.Group widths='equal'>
              <Select name='transmissionMecaniqueLubrifieAccouplement' formEntry={equipment} options={YesNo()} isFixed label='1.2.1 Lubrifié accouplement' />
              <Select name='transmissionMecaniqueLubrifiePompeAngleDroit' formEntry={equipment} options={YesNo()} isFixed label='1.2.2 Lubrifié pompe à angle droit' />
              <Select name='transmissionMecaniqueNiveauHuile' formEntry={equipment} options={ConformAdequat()} isFixed label="1.2.3 Niveau d'huile" />
            </Form.Group>
            <Divider />
            <Header as='h5'>1.3 SYSTÈME ÉLECTRIQUE</Header>
            <Form.Group widths='equal'>
              <Select name='systemElectriqueVoyantLumineux' formEntry={equipment} options={ConformAdequat()} isFixed label='1.3.1 Voyant lumineux' />
              <Select name='systemElectriqueEssaiDemarreurManuel' formEntry={equipment} options={ConformYes()} isFixed label='1.3.6 Essai du démarreur manuel' />
              <Select name='lubrifierRoulementBilleMoteur' formEntry={equipment} options={YesNo()} isFixed label='1.3.11 Lubrifier roulement à bille du moteur' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='systemElectriqueEssaiDisjoncteurIsolationPrincipal' formEntry={equipment} options={ConformYes()} isFixed label="1.3.2 Essai du disjoncteur d'isolation principal" />
              <Select name='systemElectriqueEssaiDemarreurUrgence' formEntry={equipment} options={ConformYes()} isFixed label="1.3.7 Essai du démarreur d'urgence" />
              <Select name='signalPompeMarcheD' formEntry={equipment} options={YesNo()} isFixed label='1.3.12 Signal pompe en marche (D)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='systemElectriqueEssaiDisjoncteurIsolationMoyen' formEntry={equipment} options={ConformYes()} isFixed label="1.3.3 Essai disjoncteur d'isolation moyen" />
              <Select name='essaiDeDemarrageParAlarm' formEntry={equipment} options={ConformYes()} isFixed label='1.3.8 Essai de démarrage par alarme (avertiss. de débit)' />
              <Select name='signalPanneAlimentationD' formEntry={equipment} options={ConformYes()} isFixed label='1.3.13 Signal panne alimentation (D)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='systemElectriqueEssaiInterrupteurTransfert' formEntry={equipment} options={ConformYes()} isFixed label="1.3.4 Essai de l'interrupteur de transfert" />
              <Select name='essaiCalibrationInterruptaPression' formEntry={equipment} options={ConformYes()} isFixed label="1.3.9 Essai et calibration de l'interrupt. à pression" />
              <Select name='signalInversionPhase' formEntry={equipment} options={ConformYes()} isFixed label='1.3.14 Signal inversion de phase (R)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='systemElectriqueEssaiDemarrageGeneratrice' formEntry={equipment} options={ConformYes()} isFixed label='1.3.5 Essai de démarrage de la génératrice' />
              <Select name='verificationConnectionElectrique' formEntry={equipment} options={ConformYes()} isFixed label='1.3.10 Vérification connection électrique' />
              <div className='field' />
            </Form.Group>
            <Divider />
            <Section title={(<Header as='h5'>1.4 MOTEUR DIESEL</Header>)} useDivider={false} name='moteurDiesel' equipment={equipment}>
              <Form.Group widths='equal'>
                <Select name='niveauReservoiceAu23' formEntry={equipment} options={ConformYes()} isFixed label='1.4.1 Niveau du réservoir au 2/3 (8.2.2.(4).(a))' />
                <Select name='hoseFlexiblesConnection' formEntry={equipment} options={ConformAdequat()} isRequired label='1.4.4 Hose flexibles et connections' />
                <Select name='reservoirDoubleParoit' formEntry={equipment} options={ConformYes()} isRequired label='1.4.7 Réservoir à double paroît' />
              </Form.Group>
              <Form.Group widths='equal'>
                <Select name='interrupteurBasNiveauFonct' formEntry={equipment} options={ConformYes()} isFixed label='1.4.2 Interrupteur de bas niveau fonct. (flotteur)' />
                <Select name='eventTropPleinNonObstrue' formEntry={equipment} options={ConformYes()} isFixed label='1.4.5 Évent et trop plein ne sont pas obstrués' />
                <Select name='bassinRetention' formEntry={equipment} options={ConformYes()} isRequired label='1.4.8 Bassin de rétention' />
              </Form.Group>
              <Form.Group widths='equal'>
                <Select name='tamisFiltreNettoye' formEntry={equipment} options={ConformYes()} isRequired label='1.4.3 Tamis et filtre nettoyés' />
                <Select name='tuyauterieAdequate' formEntry={equipment} options={ConformYes()} isRequired label='1.4.6 Tuyauterie adéquate' />
                <Select name='pompeInjection' formEntry={equipment} options={ConformYes()} isRequired label='1.4.9 Pompe à injection' />
              </Form.Group>
              <strong>Lubrification du système</strong>
              <Form.Group widths='equal'>
                <Select name='verificationHuileMoteur' formEntry={equipment} options={ConformYes()} isRequired label="1.4.10 Vérification de l'huile moteur" />
                <Select name='lubrificationSystemeChauffeMoteur' className='second-title' formEntry={equipment} options={ConformAdequat()} isRequired label='1.4.10.2 Chauffe moteur' />
                <Input type='Date' name='lubrificationSystemeDateDernierEntretien' className='second-title' formEntry={equipment} isRequired label='1.4.10.4 Date du dernier entretien' />
              </Form.Group>
              <Form.Group widths='equal'>
                <Select name='lubrificationSystemeNiveau' className='second-title' formEntry={equipment} options={ConformAdequat()} isRequired label='1.4.10.1 Niveau' />
                <Select name='lubrificationSystemeEntretienAnnuelEffectue' className='second-title' formEntry={equipment} options={ConformYes()} isRequired label='1.4.10.3 Entretien annuel effectué' />
                <div className='field' />
              </Form.Group>
              <strong>Système de refroidissement</strong>
              <Form.Group widths='equal'>
                <Select name='systemRefroidissementNiveauReservoir' formEntry={equipment} options={ConformAdequat()} isFixed label='1.4.11 Niveau du réservoir' />
                <Select name='systemRefroidissementTamisFiltreNettoye' formEntry={equipment} options={YesNo()} isFixed label='1.4.15 Tamis et filtre nettoyés' />
                <Select name='supportEncrage' formEntry={equipment} options={ConformAdequat()} isRequired label='1.4.19 Support et encrage' />
              </Form.Group>
              <Form.Group widths='equal'>
                <Select name='systemRefroidissementAlimentationEauRefroidisseur' formEntry={equipment} options={ConformAdequat()} isFixed label='1.4.12 Alimentation en eau au refroidisseur' />
                <Select name='systemRefroidissementValveSolenoideOperationnelle' formEntry={equipment} options={ConformYes()} isFixed label='1.4.16 Valve solénoïde opérationnelle' />
                <Select name='sectionFlexible' formEntry={equipment} options={ConformAdequat()} isRequired label='1.4.20 Section flexible' />
              </Form.Group>
              <Form.Group widths='equal'>
                <Select name='systemRefroidissementPompeEauFonctionnelle' formEntry={equipment} options={YesNo()} isFixed label="1.4.13 Pompe à l'eau fonctionnelle" />
                <Select name='echappementFuite' formEntry={equipment} options={YesNo()} isFixed label='1.4.17 Fuite' />
                <div className='field' />
              </Form.Group>
              <Form.Group widths='equal'>
                <Select name='systemRefroidissementHoseFlexibleConnection' formEntry={equipment} options={ConformAdequat()} isRequired label='1.4.14 Hose flexibles et connections' />
                <Select name='isolationProtectionAntifeu' formEntry={equipment} options={ConformYes()} isRequired label='1.4.18 Isolation et protection anti-feu' />
                <div className='field' />
              </Form.Group>
              <strong>Batterie</strong>
              <Form.Group widths='equal'>
                <Select name='niveauElectrolyte' formEntry={equipment} options={ConformAdequat()} isFixed label='1.4.21 Niveau électrolyte' />
                <Select name='etatBornies' formEntry={equipment} options={ConformAdequat()} isFixed label='1.4.22 État des borniés' />
                <Select name='etatDuBoitie' formEntry={equipment} options={ConformAdequat()} isFixed label='1.4.23 État du boitié' />
              </Form.Group>
              <strong>Système électrique</strong>
              <Form.Group widths='equal'>
                <Select name='systemeElectriqueInspectionGeneral' formEntry={equipment} options={ConformAdequat()} isFixed label='1.4.24 Inspection général' />
                <Select name='fonctSignauxMalFonctionnement' formEntry={equipment} options={ConformYes()} isFixed label='1.4.26 Fonct. de signaux de mal fonctionnement' />
                <Select name='systemeElectriquePanneauControle' formEntry={equipment} options={ConformAdequat()} isFixed label='1.4.28 Panneau de contrôle' />
              </Form.Group>
              <Form.Group widths='equal'>
                <Select name='connectionBienSerrees' formEntry={equipment} options={ConformYes()} isFixed label='1.4.25 Connections bien serrées' />
                <Select name='fonctionnementSignauxAlarme' formEntry={equipment} options={ConformYes()} isFixed label="1.4.27 Fonctionnement de signaux d'alarme" />
                <div className='field' />
              </Form.Group>
            </Section>
            <Divider />
            <Header as='h5'>1.5 POMPE DE MAINTIENT</Header>
            <Form.Group widths='equal'>
              <Select name='pompeMaintientMarque' formEntry={equipment} options={[{ value: 'albany', text: 'Albany' }, { value: 'autre', text: 'Autre' }]} isRequired label='1.5.1 Marque' />
              <Select name='pompeMaintientCommandePression' formEntry={equipment} options={ConformAdequat()} isRequired label='1.5.5 Commande à pression' />
              <Select name='pompeMaintientClapetRetenue' formEntry={equipment} options={ConformAdequat()} isRequired label='1.5.9 Clapet de retenue' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select
                name='pompeMaintientHP' formEntry={equipment} options={[
                  { value: '1/3', text: '1/3' },
                  { value: '1/2', text: '1/2' },
                  { value: '3/4', text: '3/4' },
                  { value: '1', text: '1' },
                  { value: '2', text: '2' },
                  { value: '3', text: '3' },
                  { value: '4', text: '4' },
                  { value: '5', text: '5' },
                  { value: 'Autres', text: 'Autres' }
                ]} isRequired label='1.5.2 HP'
              />
              <Select name='pompeMaintientPanneauControle' formEntry={equipment} options={ConformAdequat()} isRequired label='1.5.6 Panneau de contrôle' />
              <Select name='pompeMaintientFonctionnement' formEntry={equipment} options={ConformAdequat()} isRequired label='1.5.10 Fonctionnement' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='pompeMaintientDelaiPompage' formEntry={equipment} options={FromTo(1, 60)} isRequired label='1.5.7 Délai de pompage (min)' />
              <Select name='pompeMaintientLubrification' formEntry={equipment} options={YesNo()} isFixed label='1.5.11 Lubrification' />
              <div className='field' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='pompeMaintientConditionTuyauterie' formEntry={equipment} options={ConformAdequat()} isRequired label='1.5.4 Condition de la tuyauterie' />
              <Select name='pompeMaintientSoupapeSurete' formEntry={equipment} options={ConformAdequat()} isRequired label='1.5.8 Soupape de sureté' />
              <div className='field' />
            </Form.Group>
            <Divider />
            <Header as='h5'>1.6 ESSAI DE PERFORMANCE DE POMPE INCENDIE AVEC LE DÉBITMÈTRE</Header>
            <Form.Group widths='equal'>
              <Select name='dernierEssaiEffectueDebitmetre' formEntry={equipment} options={Years()} isRequired label='1.6.1 Dernier essai effectué avec débitmètre (a.)' />
              <Select name='prochainEssaiEcoulementEau' formEntry={equipment} options={Years()} isRequired label="1.6.2 Prochain essai avec écoulement d'eau" />
              <div className='field' />
            </Form.Group>
          </Section>
          <Section title={(<Header as='h2'>2. ESSAIS DE PERFORMANCE DE LA POMPE À INCENDIE</Header>)} name='moteurDiesel' equipment={equipment}>
            <Grid padded='vertically'>
              <Grid.Row columns={3} className='compact'>
                <Grid.Column><strong>2.1 POMPE</strong></Grid.Column>
                <Grid.Column />
                <Grid.Column />
              </Grid.Row>
              <Grid.Row columns={3} className='compact'>
                <Grid.Column>
                  <Input name='modele' formEntry={equipment} label='2.1.1 Modèle' />
                </Grid.Column>
                <Grid.Column>
                  <Select
                    name='pompeManifacturier' formEntry={equipment} options={[
                      { value: 'armstrong', text: 'Armstrong' },
                      { value: 'plad', text: 'Plad' },
                      { value: 'ittFluid', text: 'itt fluid' },
                      { value: 'darlingArmstrong', text: 'darling&armstrong' },
                      { value: 'bellGossett', text: 'bell&gossett' }
                    ]} label='2.1.2 Manifacturier'
                  />
                </Grid.Column>
                <Grid.Column>
                  <Form.Group widths='equal'>
                    <Select name='pompeApprouve' formEntry={equipment} options={YesNo()} label='2.1.3 Approuvé' />
                    <Input name='pompeNoSerie' formEntry={equipment} label='2.1.4 No de série' />
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={6} className='compact'>
                <Grid.Column verticalAlign='middle'>
                  <Checkbox name='pompeHorizontal' formEntry={equipment} label='2.1.5 Horizontal' />
                </Grid.Column>
                <Grid.Column verticalAlign='middle'>
                  <Checkbox
                    name='pompeVertical' onChange={(checked) => {
                      this.setState({ pompeVertical: !!checked })
                    }} formEntry={equipment} label='2.1.6 Vertical'
                  />
                </Grid.Column>
                <Grid.Column>
                  <Input name='pompeRPM' formEntry={equipment} label='2.1.7 RPM' />
                </Grid.Column>
                <Grid.Column>
                  <Select
                    onAfterChanged={(name, value) => {
                      this.setState({ pompeSourceEau: value !== 'ville' })
                    }}
                    name='pompeSourceEau' formEntry={equipment} options={[
                      { value: 'bassin', text: 'Bassin' },
                      { value: 'reservoir', text: 'Réservoir' },
                      { value: 'ville', text: 'Ville' }
                    ]} label="2.1.8 Source d'eau"
                  />
                </Grid.Column>
                <Grid.Column>
                  {pompeSourceEau && (
                    <Input name='pompeGrandeurReservoir' formEntry={equipment} label='2.1.9 Grandeur réservoir' />
                  )}
                </Grid.Column>
                <Grid.Column>
                  {pompeSourceEau && (
                    <Input name='pompeHauteurReservoir' formEntry={equipment} label='2.1.10 Hauteur réservoir' />
                  )}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={6} className='compact'>
                <Grid.Column>
                  <Select
                    name='pompeGPM' formEntry={equipment} options={[
                      { value: '100', text: '100' },
                      { value: '150', text: '150' },
                      { value: '200', text: '200' },
                      { value: '250', text: '250' },
                      { value: '500', text: '500' },
                      { value: '750', text: '750' },
                      { value: '1000', text: '1000' },
                      { value: '1250', text: '1250' },
                      { value: '1500', text: '1500' },
                      { value: '1750', text: '1750' },
                      { value: '2000', text: '2000' },
                      { value: '3000', text: '3000' }
                    ]} label='2.1.11 GPM'
                  />
                </Grid.Column>
                <Grid.Column>
                  <Input name='pompeRatedHeadFt' formEntry={equipment} label='2.1.12 RATED HEAD-FT' />
                </Grid.Column>
                <Grid.Column>
                  <Select name='pompePressionShutOff' formEntry={equipment} options={FromTo(0, 200)} label='2.1.13 Pression shut-off' />
                </Grid.Column>
                <Grid.Column>
                  <Select name='pompePressionNominal' formEntry={equipment} options={FromTo(0, 200)} label='2.1.14 Pression nominal' />
                </Grid.Column>
                <Grid.Column>
                  <Select name='pompePression150' formEntry={equipment} options={FromTo(0, 200)} label='2.1.15 Pression à 150%' />
                </Grid.Column>
                <Grid.Column />
              </Grid.Row>
              {pompeVertical && (
                <Grid.Row columns={3} className='compact'>
                  <Grid.Column><strong>SI TYPE VERTICAL</strong></Grid.Column>
                  <Grid.Column>
                    <Form.Group widths='equal'>
                      <Select name='typeVerticalApprouve' formEntry={equipment} options={YesNo()} label='2.1.16 Approuvé' />
                      <Input name='typeVerticalNoSerie' formEntry={equipment} label='2.1.17 No de série' />
                    </Form.Group>
                  </Grid.Column>
                  <Grid.Column />
                </Grid.Row>
              )}
              <Grid.Row columns={3} className='compact'>
                <Grid.Column>Distance déchargement de la jauge au niveau d'eau</Grid.Column>
                <Grid.Column>Angle droit embrayage principale</Grid.Column>
                <Grid.Column />
              </Grid.Row>
              <Grid.Row columns={6} className='compact'>
                <Grid.Column><Input name='typeVerticalStatique' formEntry={equipment} label='2.1.19 Statique (psi)' /></Grid.Column>
                <Grid.Column><Input name='typeVerticalPompage' formEntry={equipment} label='2.1.20 Pompage (psi)' /></Grid.Column>
                <Grid.Column><Input name='typeVerticalManufacturier' formEntry={equipment} label='2.1.21 Manufacturier' /></Grid.Column>
                <Grid.Column><Input name='typeVerticalModele' formEntry={equipment} label='2.1.22 Modèle' /></Grid.Column>
                <Grid.Column><Input name='typeVerticalPerformanceReguliere' formEntry={equipment} label='2.1.23 Performance régulière' /></Grid.Column>
                <Grid.Column><Input name='typeVerticalPerformanceNonReguliere' formEntry={equipment} label='2.1.24 Performance non-régulière' /></Grid.Column>
              </Grid.Row>
              <Divider className='dashed' />
              <Grid.Row columns={3} className='compact'>
                <Grid.Column><strong>2.2 MOTEUR</strong></Grid.Column>
                <Grid.Column>
                  <Input name='moteurFacteurService' formEntry={equipment} label='2.2.1 Facteur de service' />
                </Grid.Column>
                <Grid.Column />
              </Grid.Row>
              <Grid.Row columns={6} className='compact'>
                <Grid.Column><Input name='moteurManufacturier' formEntry={equipment} label='2.2.2 Manufacturier' /></Grid.Column>
                <Grid.Column><Select name='moteurApprouve' formEntry={equipment} options={YesNo()} label='2.2.3 Approuvé' /></Grid.Column>
                <Grid.Column><Input name='moteurNoSerie' formEntry={equipment} label='2.2.4 No de série' /></Grid.Column>
                <Grid.Column><Input name='moteurModele' formEntry={equipment} label='2.2.5 Modèle' /></Grid.Column>
                <Grid.Column><Select name='moteurHP' formEntry={equipment} label='2.2.6 HP' options={FromTo(0, 100)} /></Grid.Column>
                <Grid.Column><Select name='moteurRPM' formEntry={equipment} label='2.2.7 RPM' options={FromTo(500, 3000, 100)} /></Grid.Column>
              </Grid.Row>
              <Grid.Row columns={6} className='compact'>
                <Grid.Column><Input name='moteurTypeMoteur' formEntry={equipment} label='2.2.8 Type de moteur' /></Grid.Column>
                <Grid.Column><Input name='moteurVoltageOperation' formEntry={equipment} label="2.2.9 Voltage d'opération" /></Grid.Column>
                <Grid.Column><Input name='moteurRatedFLAmps' formEntry={equipment} label='2.2.10 Rated F.L Amps' /></Grid.Column>
                <Grid.Column><Input name='moteurAmpere150' formEntry={equipment} label='2.2.11 Ampère à 150%' /></Grid.Column>
                <Grid.Column><Select name='moteurPhase' formEntry={equipment} label='2.2.12 Phase' options={FromTo(1, 3)} /></Grid.Column>
                <Grid.Column><Select
                  name='moteurCycle' formEntry={equipment} label='2.2.13 Cycle' options={[
                    { value: '50', text: '50' },
                    { value: '60', text: '60' }
                  ]}
                             />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={6} className='compact'>
                <Grid.Column><Input name='moteurVoltage' formEntry={equipment} label='2.2.14 Voltage' /></Grid.Column>
                <Grid.Column><Input name='moteurMoteurGaz' formEntry={equipment} label='2.2.15 Moteur Gaz' /></Grid.Column>
                <Grid.Column><Input name='moteurMoteurVapeur' formEntry={equipment} label='2.2.16 Moteur Vapeur' /></Grid.Column>
                <Grid.Column><Input name='moteurPressGovernorBuiltIn' formEntry={equipment} label='2.2.17 Press. Governor Bult-in' /></Grid.Column>
                <Grid.Column><Input name='moteurIndependant' formEntry={equipment} label='2.2.18 Indépendant' /></Grid.Column>
                <Grid.Column><Input name='moteurTurbineSteamPress' formEntry={equipment} label='2.2.19 Turbine Steam Press' /></Grid.Column>
              </Grid.Row>
              <Divider className='dashed' />
              <Grid.Row columns={1} className='compact'>
                <Grid.Column><strong>2.3 CONTROLEUR</strong></Grid.Column>
              </Grid.Row>
              <Grid.Row columns={3} className='compact'>
                <Grid.Column>
                  <Form.Group widths='equal'>
                    <Select
                      name='controleurManufacturier' formEntry={equipment} options={[
                        { value: 'tornatech', text: 'Tornatech' },
                        { value: 'armstrong', text: 'Armstrong' },
                        { value: 'generalElectric', text: 'General electric' }
                      ]} label='2.3.1 Manufacturier'
                    />
                    <Select name='controleurApprouve' formEntry={equipment} options={YesNo()} label='2.3.2 Approuvé' />
                  </Form.Group>
                </Grid.Column>
                <Grid.Column><Input name='controleurDepart' formEntry={equipment} label='2.3.3 Départ' /></Grid.Column>
                <Grid.Column>
                  <Form.Group widths='equal'>
                    <Input name='controleurArret' formEntry={equipment} label='2.3.4 Arrêt' />
                    <Select name='controleurJuckeyPump' formEntry={equipment} options={YesNo()} label='2.3.5 Juckey Pump' />
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={6} className='compact'>
                <Grid.Column><Input name='controleurNoSerie' formEntry={equipment} label='2.3.6 No de série' /></Grid.Column>
                <Grid.Column><Input name='controleurModele' formEntry={equipment} label='2.3.7 Modèle' /></Grid.Column>
                <Grid.Column><Select name='controleurDepartManuelAuto' formEntry={equipment} options={[{ value: 'manuel', text: 'Manuel' }, { value: 'auto', text: 'Auto' }]} label='2.3.8 Manuel ou auto' /></Grid.Column>
                <Grid.Column><Select name='controleurDepartPressWater' formEntry={equipment} options={[{ value: 'press', text: 'Press drop' }, { value: 'water', text: 'Water flow' }]} label='2.3.9 Press drop ou water flow' /></Grid.Column>
                <Grid.Column><Select name='controleurArretManuelAuto' formEntry={equipment} options={[{ value: 'manuel', text: 'Manuel' }, { value: 'auto', text: 'Auto' }]} label='2.3.10 Manuel ou auto' /></Grid.Column>
                <Grid.Column><Input name='controleurPompeMaintient' formEntry={equipment} label='2.3.11 Pompe de maintient (psi)' /></Grid.Column>
              </Grid.Row>
              <Grid.Row columns={6} className='compact'>
                <Grid.Column />
                <Grid.Column />
                <Grid.Column />
                <Grid.Column />
                <Grid.Column />
                <Grid.Column><Input name='controleurManometreDernierEtage' formEntry={equipment} label='2.3.12 Manomètre dernier étage (psi)' /></Grid.Column>
              </Grid.Row>
              <Divider className='thick' />
              <Grid.Row columns={12} textAlign='center' className='compact'>
                <Grid.Column />
                <Grid.Column />
                <Grid.Column />
                <Grid.Column />
                <Grid.Column />
                <Grid.Column>SORTIE</Grid.Column>
                <Grid.Column />
                <Grid.Column />
                <Grid.Column />
                <Grid.Column />
                <Grid.Column>AMPÉRAGE</Grid.Column>
                <Grid.Column />
              </Grid.Row>
              <Grid.Row columns={12} textAlign='center' className='compact'>
                <Grid.Column>RPM vitesse</Grid.Column>
                <Grid.Column>Pression décharge PSI</Grid.Column>
                <Grid.Column>Pression succion PSI</Grid.Column>
                <Grid.Column>Po Net PSI</Grid.Column>
                <Grid.Column>No</Grid.Column>
                <Grid.Column>Grosseur</Grid.Column>
                <Grid.Column>Pression Pitot</Grid.Column>
                <Grid.Column>Gallons par Minute</Grid.Column>
                <Grid.Column>% Capacité NOMINALE</Grid.Column>
                <Grid.Column>T1</Grid.Column>
                <Grid.Column>T2</Grid.Column>
                <Grid.Column>T3</Grid.Column>
              </Grid.Row>
              {[...Array(7)].map((x, i) => {
                const index = ++i
                return (
                  <Grid.Row key={`tableRow${index}`} columns={12} textAlign='center' className='compact'>
                    <Grid.Column><Input name={`tableauRPM${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauDecharge${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauSuccion${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauNet${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauNo${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauGrosseur${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauPressionPitot${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauGallonsMinute${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauCapacite${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauT1${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauT2${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauT3${index}`} formEntry={equipment} /></Grid.Column>
                  </Grid.Row>
                )
              })}
              <Grid.Row>
                <Grid.Column>
                  <Line data={data} options={options} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Divider className='dashed' />
            <Form.Group widths='equal'>
              <Input type='date' name='essaiPerformanceDate' formEntry={equipment} label='Date' />
              <Select
                name='essaiConform' formEntry={equipment} options={[
                  { value: 'conforme', text: 'Conforme' },
                  { value: 'nonconforme', text: 'Non-conforme' }
                ]} label='Conforme'
              />
            </Form.Group>
          </Section>
        </Form>
      </>
    )
  }
}

RIGPMP000.fieldsRequired = [
  {
    section: '10pompeIncendie',
    fields: [
      'tuyauterieEssaiDebitmetreAdequat',
      'conditionArbreEntrainement',
      'diametreAlimentationSortie',
      'manometreCapteur',
      'valveEntreTypeOSY',
      'diametreTuyauterieContournement',
      'alignementAccouplement',
      'valveEntreTypeNormalementFerme',
      'valveContournement',
      'conditionExterneTuyauterie',
      'tuyauterieRaccordEassiAdequat',
      'vlapetRetenue',
      'hoseFlexiblesConnection',
      'reservoirDoubleParoit',
      'bassinRetention',
      'tamisFiltreNettoye',
      'tuyauterieAdequate',
      'pompeInjection',
      'verificationHuileMoteur',
      'lubrificationSystemeChauffeMoteur',
      'lubrificationSystemeDateDernierEntretien',
      'lubrificationSystemeNiveau',
      'lubrificationSystemeEntretienAnnuelEffectue',
      'supportEncrage',
      'sectionFlexible',
      'systemRefroidissementHoseFlexibleConnection',
      'isolationProtectionAntifeu',
      'pompeMaintientMarque',
      'pompeMaintientCommandePression',
      'pompeMaintientClapetRetenue',
      'pompeMaintientHP',
      'pompeMaintientPanneauControle',
      'pompeMaintientFonctionnement',
      'pompeMaintientDelaiPompage',
      'pompeMaintientConditionTuyauterie',
      'pompeMaintientSoupapeSurete',
      'dernierEssaiEffectueDebitmetre',
      'prochainEssaiEcoulementEau'
    ]
  }
]

export default RIGPMP000
